import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Award } from 'lucide-react';

export default function AdminRewardSystem() {
  return (
    <div className="container mx-auto p-6 max-w-7xl">
      <div className="mb-6">
        <h1 className="text-3xl font-bold text-white mb-2">Reward System</h1>
        <p className="text-[#8A93A6]">Reward programs, incentive management, and distribution</p>
      </div>
      <Card className="glass">
        <CardHeader>
          <CardTitle className="text-base flex items-center gap-2 text-white">
            <Award className="h-5 w-5 text-pink-500" />
            Reward Configuration
          </CardTitle>
        </CardHeader>
        <CardContent>
          <p className="text-sm text-[#8A93A6]">Reward program configuration, incentive tracking, and distribution management will be handled here.</p>
        </CardContent>
      </Card>
    </div>
  );
}
